import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const API_URL = 'https://rickandmortyapi.com/api/character/';

const DataContext = createContext({});

export function DataProvider({ children }) {
  const [activePage, setActivePage] = useState(0);
  const [characters, setCharacters] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isError, setIsError] = useState(false);
  const [info, setInfo] = useState({});
  const [apiURL, setApiURL] = useState(API_URL);

  useEffect(() => {
    setIsFetching(true);
    setIsError(false);
    setCharacters([]);

    fetch(apiURL)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');

        return res.json();
      })
      .then((data) => {
        setCharacters(data.results);
        setInfo(data.info);
        setIsFetching(false);
      })
      .catch((e) => {
        setIsError(true);
        setIsFetching(false);
        console.error(e);
      });
  }, [apiURL]);

  const dataValue = useMemo(
    () => ({
      activePage,
      setActivePage,
      apiURL,
      setApiURL,
      characters,
      isFetching,
      isError,
      info
    }),
    [activePage, apiURL, characters, isFetching, isError, info]
  );

  return (
    <DataContext.Provider value={dataValue}>{children}</DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
